import { render, staticRenderFns } from "./EventHistoryTop.vue?vue&type=template&id=2f5ff547&"
import script from "./EventHistoryTop.vue?vue&type=script&lang=ts&"
export * from "./EventHistoryTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports